// Logo variants for Faith Family Finance.
// Pass variant="tree" or variant="wordmark" to switch.

export function Logo({ variant = "tree", className = "" }) {
  if (variant === "wordmark") {
    return (
      <div className={`leading-tight ${className}`}>
        <div className="font-serif text-xl sm:text-[1.55rem] text-primary tracking-tight">
          Faith Family Finance
        </div>
        <div className="text-[9px] sm:text-[10px] uppercase tracking-[0.22em] sm:tracking-[0.28em] text-muted-foreground mt-0.5">
          Life insurance, done right
        </div>
      </div>
    );
  }

  // tree: inline SVG family-tree mark + wordmark
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <span className="h-10 w-10 rounded-full bg-primary flex items-center justify-center shrink-0">
        <TreeMark className="h-5 w-5 text-primary-foreground" />
      </span>
      <div className="leading-tight">
        <div className="font-serif text-xl text-primary tracking-tight">Faith Family Finance</div>
        <div className="text-[10px] uppercase tracking-[0.25em] text-muted-foreground">Life insurance, done right</div>
      </div>
    </div>
  );
}

function TreeMark({ className = "" }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      {/* trunk */}
      <path d="M12 21V12" />
      {/* branches */}
      <path d="M12 12 L7 8" />
      <path d="M12 12 L17 8" />
      <path d="M12 14 L9 17" />
      <path d="M12 14 L15 17" />
      {/* leaf nodes */}
      <circle cx="7" cy="8" r="1.6" fill="currentColor" />
      <circle cx="17" cy="8" r="1.6" fill="currentColor" />
      <circle cx="12" cy="4.5" r="1.8" fill="currentColor" />
      <circle cx="9" cy="17" r="1.4" fill="currentColor" />
      <circle cx="15" cy="17" r="1.4" fill="currentColor" />
      {/* trunk top-to-crown */}
      <path d="M12 12 L12 6.2" />
    </svg>
  );
}
